// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerImage_container__28voS"};